import { render, staticRenderFns } from "./PrivacyKeusote.vue?vue&type=template&id=db69680a&scoped=true&"
import script from "./PrivacyKeusote.vue?vue&type=script&lang=ts&"
export * from "./PrivacyKeusote.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyKeusote.vue?vue&type=style&index=0&id=db69680a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db69680a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCheckbox,VCol,VContainer,VRow})
